import React, { useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "../css/dark-mode.css";
import LeagueOverview from "./LeagueOverview";
import RosterOverview from "./RosterOverview";
import TeamComparison from "./TeamComparison";

const App = (props) => {
  useEffect(() => {
    // Apply dark mode class to body on mount
    document.body.classList.add('dark-mode');
  }, []);

  return (
    <div className="dark-mode">
      <Tabs>
        <TabList>
          <Tab>League Overview</Tab>
          <Tab>Roster Overview</Tab>
          <Tab>Team Comparison</Tab>
        </TabList>

        <TabPanel>
          <LeagueOverview league_id={props.league_id} />
        </TabPanel>
        <TabPanel>
          <RosterOverview league_id={props.league_id} />
        </TabPanel>
        <TabPanel>
          <TeamComparison league_id={props.league_id} />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default App;
